var _g, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgTrustradius = function SvgTrustradius(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.1211 45.4717C76.7528 45.7855 77.3845 46.0993 77.8583 46.57L105.18 73.7136C106.285 74.8119 106.917 76.224 106.917 77.793V202.999C106.917 204.097 106.127 204.882 105.022 204.882C104.548 204.882 104.074 204.725 103.758 204.411L78.0162 178.836C76.9107 177.738 76.279 176.326 76.279 174.757V45.4717H76.1211Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.295 46.7269C151.769 46.2562 152.401 45.7855 153.033 45.4717V174.757C153.033 176.326 152.401 177.738 151.295 178.836L125.553 204.411C124.763 205.196 123.658 205.196 122.868 204.411C122.552 204.097 122.395 203.627 122.395 203.156V77.9499C122.395 76.5378 123.026 74.9689 124.132 74.0275L151.295 46.7269Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.885 146.201L198.99 144.318V117.646H172.932C172.458 117.646 171.984 117.802 171.51 118.273L152.875 136.787L212.572 196.252C213.677 197.351 215.099 197.821 216.678 197.821H248.106C249.211 197.821 250.001 197.037 250.001 195.939C250.001 195.468 249.843 194.997 249.527 194.683L200.885 146.201Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.243 45C153.664 45 152.242 45.6276 151.137 46.7259L123.815 73.8695C123.342 74.3402 123.026 74.9678 122.71 75.4385H198.989V144.161L200.884 146.043L228.048 119.214C229.153 118.115 229.785 116.703 229.785 115.134V77.9489C229.785 76.38 229.153 74.9678 228.048 73.8695L200.726 46.7259C199.621 45.6276 198.199 45 196.62 45H155.243Z",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7005 46.7259C76.595 45.6276 75.1737 45 73.5944 45H1.89514C0.789641 45 0 45.7845 0 46.8828C0 47.3535 0.157927 47.8242 0.631711 48.2949L26.374 73.8695C27.4795 74.9678 28.9008 75.5955 30.4801 75.5955H103.127C105.18 75.5955 106.917 77.3213 106.917 79.361V77.949C106.917 76.38 106.285 74.9678 105.18 73.8695L77.7005 46.7259Z",
    fill: "url(#paint4_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.137 46.7259C152.243 45.6276 153.664 45 155.244 45H196.621C198.2 45 199.621 45.6276 200.727 46.7259L228.048 73.8695C229.154 74.9678 229.785 76.38 229.785 77.949V79.361C229.785 77.3213 228.048 75.5955 225.995 75.5955H126.185C124.132 75.5955 122.395 77.3213 122.395 79.361V77.949C122.395 76.38 123.026 74.9678 124.132 73.8695L151.137 46.7259Z",
    fill: "url(#paint5_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.785 113.724C229.785 115.763 228.048 117.489 225.995 117.489H174.51C174.036 117.489 173.562 117.96 173.562 118.431C173.562 118.744 173.72 118.901 173.878 119.058L201.042 146.045L228.206 119.215C229.311 118.117 229.943 116.705 229.943 115.136V113.724H229.785Z",
    fill: "url(#paint6_linear)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 91.4427,
    y1: 205.421,
    x2: 91.4427,
    y2: 45.0782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#116BF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E50E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 137.553,
    y1: 205.452,
    x2: 137.553,
    y2: 45.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#116BF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E50E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 169.753,
    y1: 120.9,
    x2: 244.197,
    y2: 195.831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#116BF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#185DEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 176.229,
    y1: 145.655,
    x2: 176.229,
    y2: 43.9522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#116BF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E50E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 73.1462,
    y1: 43.1268,
    x2: 42.6054,
    y2: 73.8677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#59C5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#21B1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 148.231,
    y1: 49.895,
    x2: 178.771,
    y2: 80.6359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#59C5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#21B1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 216.736,
    y1: 131.318,
    x2: 193.83,
    y2: 108.262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#57C4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#21B1FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 250,
    height: 250,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTrustradius, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/trustradius.6217b05b.svg";
export { ForwardRef as ReactComponent };